module.exports = __webpack_public_path__ + "img/cart-empty.6f45f705.png";